import React, { useState, useEffect, lazy, Suspense } from 'react'
import { Grid, Button } from '@material-ui/core'
import './styles/viewFormsDraft.scss'
import { useHistory } from 'react-router-dom'
import ExitIcon from '@material-ui/icons/ExitToApp'
import ReactTooltip from 'react-tooltip'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import DeleteIcon from '@mui/icons-material/Delete'
import InputLabel from '@mui/material/InputLabel'
import FormControl from '@mui/material/FormControl'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import { useForm } from '../../../../../context/formContext'
import { getListFormDraftFilters } from '../../../../../services/Forms/get'
import DatePicker from 'react-datepicker'
import es from 'date-fns/locale/es'
import 'react-datepicker/dist/react-datepicker.css'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'
// import { stage } from '../../../../../config/api'
const TableData = lazy(() => import('./CollapsibleTable'))

const ViewForms = () => {
  const {
    getDraftListForm,
    listDraftForms,
    setFetchRequest,
    statesCodesDraft,
    setListForms,
    ActualDraftPage,
    pageDraftSize,
    pagesCounter,
    setListDraftForms,
    setPagesDraftCount,
    projectNameDraft,
    setActualDraftPage,
    setPageDraftSize,
    loadingPDF,
  } = useForm()

  const history = useHistory()

  const [statusFilter, setStatusFilter] = useState('')

  // filtro por etapa de proyecto
  const [projectStage, setprojectStage] = useState('')

  const [filtersOn, setFiltersOn] = useState(false)

  const cancelForm = () => {
    history.push('/')
  }

  // const [anchorEl, setAnchorEl] = React.useState(null)

  // const open = Boolean(anchorEl)

  /* const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  } 
  const handleClose = () => {
    setAnchorEl(null)
  }
  */

  const handleState = (e) => {
    setStatusFilter(e)
  }

  const handleProjectStage = (e) => {
    setprojectStage(e)
  }

  const [cleanFilters, setCleanFilters] = useState(false)

  const limpiarFiltros = () => {
    setActualDraftPage(1)
    setPageDraftSize(10)
    setStatusFilter('')
    setprojectStage('')
    setprojectsName('')
    setStartDate('')
    setCleanFilters(true)
  }

  useEffect(() => {
    if (cleanFilters) {
      getDraftListForm()
      setCleanFilters(false)
    } else {
      setCleanFilters(false)
    }
  }, [cleanFilters])

  const [projectsName, setprojectsName] = useState('')

  const handleProjectName = (e) => {
    setprojectsName(e)
  }

  const getFiltersDraftForms = async () => {
    setListDraftForms({ loading: true, list: [] })
    let localDate = ''

    if (startDate !== '' && startDate !== undefined && startDate !== null) {
      localDate = new Date(startDate).toLocaleDateString()
    }

    await getListFormDraftFilters(
      ActualDraftPage,
      pageDraftSize,
      statusFilter,
      projectStage,
      localDate,
      projectsName,
    )
      .then((res) => {
        setListDraftForms({ loading: false })
        if (!res.response.ok) {
          setListDraftForms({ loading: false, list: [] })
        } else {
          const list = res?.formsPreElegibility
          const pages = pagesCounter(
            res?.pagination.totalRecords,
            pageDraftSize,
          )
          setPagesDraftCount(pages)
          setListDraftForms({ loading: false, list: list })
          listado(res.formsPreElegibility)
        }
      })
      .catch((err) => {
        console.log(err)
        setListForms({ loading: false, list: [] })
      })
  }

  useEffect(() => {
    if (filtersOn && ActualDraftPage !== 1) {
      setActualDraftPage(1)
    }
    if (filtersOn) {
      getFiltersDraftForms()
      setFiltersOn(false)
    }
  }, [filtersOn, ActualDraftPage])

  const [rows, setRows] = useState(null)

  const formatDate = (str) => {
    const date = new Date(str)
    return date.toLocaleDateString()
  }

  const listado = (list) => {
    const updateRow = []

    if (list.length > 0) {
      list.map((item) =>
        updateRow.push({
          idFormType: item.idFormType,
          dateCreated: item.dateCreated ? formatDate(item.dateCreated) : '',
          miPymeBusinessName: item.miPymeBusinessName
            ? item.miPymeBusinessName
            : '',
          countryLargeName: item.countryLargeName ? item.countryLargeName : '',
          ifiFullName: item.ifiFullName ? item.ifiFullName : '',
          idFormStatus: item.idFormStatus ? item.idFormStatus : '',
          formStatusDescription: item.formStatusDescription
            ? item.formStatusDescription
            : '',
          formsPreElegibilityHistoryDto: item.formsPreElegibilityHistoryDto
            ? item.formsPreElegibilityHistoryDto
            : '',
          miPymeIdentification: item.miPymeIdentification
            ? item.miPymeIdentification
            : '',
          miPymeDepartment: item.miPymeDepartment ? item.miPymeDepartment : '',
          miPymeMunicipality: item.miPymeMunicipality
            ? item.miPymeMunicipality
            : '',
          miPymePhone: item.miPymePhone ? item.miPymePhone : '',
          miPymeAdress: item.miPymeAdress ? item.miPymeAdress : '',
          legalRepresentativeFullName: item.legalRepresentativeFullName
            ? item.legalRepresentativeFullName
            : '',
          identificationLegalRepresentative:
            item.identificationLegalRepresentative
              ? item.identificationLegalRepresentative
              : '',
          stage: item.stage ? item.stage : '',
        }),
      )
    }

    setRows(updateRow)
  }

  useEffect(() => {
    setFetchRequest(['view_draft_form'])
  }, [])

  useEffect(() => {
    if (listDraftForms.list && listDraftForms.list.length >= 0) {
      listado(listDraftForms.list)
    } else {
      listado([])
    }
  }, [listDraftForms])

  const [startDate, setStartDate] = useState('')

  const handleDate = (e) => {
    setStartDate(e)
  }

  return (
    <Grid
      container
      style={{
        width: '100%',
        height: 'auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px',
      }}
    >
      <div
        style={{
          height: 'auto',
          width: '96%',
          backgroundColor: '#fff',
          borderRadius: '4px',
          marginTop: '10px',
        }}
      >
        <Grid md={12} sm={12}>
          <div className="tableTitle">
            <Grid item md={12} xs={12} style={{ padding: '20px' }}>
              <h1
                style={{
                  fontSize: '30px',
                  fontWeight: '900',
                  color: '#111',
                }}
              >
                Consulta Formularios
              </h1>
              <p
                style={{
                  paddingLeft: '3px',
                  paddingTop: '5px',
                  marginTop: '1%',
                }}
              >
                Visualice y edite los formularios no completados
              </p>
              <div className="options">
                <div
                  data-tip
                  data-for="exitPop"
                  style={{
                    backgroundColor: 'red',
                    color: '#fff',
                    width: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '4px',
                    padding: '5px',
                    cursor: 'pointer',
                  }}
                  onClick={() => cancelForm()}
                >
                  <ExitIcon style={{ transform: 'scaleX(-1)' }} />
                  <ReactTooltip
                    id="exitPop"
                    effect="solid"
                    backgroundColor="red"
                  >
                    <span>Regresar</span>
                  </ReactTooltip>
                </div>

                {/**
                <Button
                  data-tip
                  data-for="exportPop"
                  id="basic-button"
                  aria-controls={open ? 'basic-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? 'true' : undefined}
                  onClick={handleClick}
                  style={{
                    backgroundColor: '#26be80',
                    color: '#fff',
                    width: 'auto',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '4px',
                    padding: '10px',
                    cursor: 'pointer',
                    marginLeft: '16px',
                  }}
                >
                  Exportar
                  <FileDownloadIcon
                    style={{
                      color: '#fff',
                      marginLeft: '5px',
                    }}
                  />
                </Button>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    'aria-labelledby': 'basic-button',
                  }}
                >
                  <MenuItem onClick={handleClose}>Exportar PDF</MenuItem>
                  <MenuItem onClick={handleClose}>Exportar Excel</MenuItem>
                </Menu>
                <ReactTooltip
                  id="exportPop"
                  effect="solid"
                  backgroundColor="#25bc81"
                >
                  <span>Exportar PDF o Excel</span>
                </ReactTooltip>
 */}
                {listDraftForms.loading || loadingPDF ? (
                  <Button
                    data-tip
                    data-for="cleanFilters"
                    id="basic-button"
                    aria-controls={open ? 'basic-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    className="buttonOptionsDisabled"
                  >
                    Limpiar Filtros
                    <DeleteIcon
                      style={{
                        color: '#fff',
                        marginLeft: '5px',
                      }}
                    />
                  </Button>
                ) : (
                  <Button
                    data-tip
                    data-for="cleanFilters"
                    id="basic-button"
                    aria-controls={open ? 'basic-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    className="buttonOptions"
                    onClick={() => limpiarFiltros()}
                  >
                    Limpiar Filtros
                    <DeleteIcon
                      style={{
                        color: '#fff',
                        marginLeft: '5px',
                      }}
                    />
                  </Button>
                )}

                <ReactTooltip
                  id="cleanFilters"
                  effect="solid"
                  backgroundColor="#0d53ad"
                >
                  <span>Limpiar filtros seleccionados</span>
                </ReactTooltip>

                {listDraftForms.loading || loadingPDF ? (
                  <Button
                    data-tip
                    data-for="filters"
                    id="basic-button"
                    aria-controls={open ? 'basic-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    className="buttonOptionsDisabled breakButton"
                  >
                    Filtrar
                    <FilterAltIcon />
                  </Button>
                ) : (
                  <Button
                    data-tip
                    data-for="filters"
                    id="basic-button"
                    aria-controls={open ? 'basic-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    className="buttonOptions breakButton"
                    onClick={() => setFiltersOn(true)}
                  >
                    Filtrar
                    <FilterAltIcon />
                  </Button>
                )}

                <ReactTooltip
                  id="filters"
                  effect="solid"
                  backgroundColor="#0d53ad"
                >
                  <span>Búsqueda por filtros seleccionados</span>
                </ReactTooltip>
              </div>
            </Grid>
          </div>
          <Grid md={12} sm={12}>
            <div className="tableOptions">
              <Grid md={12} sm={12} xs={12}>
                <div className="tableFilters">
                  <Grid
                    md={6}
                    sm={6}
                    xs={12}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginBottom: '10px',
                    }}
                  >
                    <Grid md={11} sm={11} xs={10}>
                      <FormControl fullWidth>
                        <DatePicker
                          selected={startDate}
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dateFormat="dd/MM/yyyy"
                          dropdownMode="select"
                          locale={es}
                          placeholderText="Fecha"
                          onChangeRaw={(e) => e.preventDefault()}
                          onChange={(date) => handleDate(date)}
                          disabled={listDraftForms.loading}
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                  <Grid
                    md={6}
                    sm={6}
                    xs={12}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginBottom: '10px',
                    }}
                  >
                    <Grid md={11} sm={11} xs={10}>
                      <FormControl fullWidth disabled={listDraftForms.loading}>
                        <InputLabel>Nombre Proyecto</InputLabel>
                        <Select
                          id="NombreProyecto"
                          label="Nombre Proyecto"
                          value={projectsName}
                          onChange={(e) => {
                            handleProjectName(e.target.value)
                          }}
                        >
                          <MenuItem value={''}>Seleccione una opción</MenuItem>
                          {projectNameDraft &&
                            projectNameDraft.map((item, key) => (
                              <MenuItem key={key} value={item}>
                                {item}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                  <Grid
                    md={6}
                    sm={6}
                    xs={12}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginBottom: '10px',
                    }}
                  >
                    <Grid md={11} sm={11} xs={10}>
                      <FormControl fullWidth disabled={listDraftForms.loading}>
                        <InputLabel>Estados</InputLabel>
                        <Select
                          id=""
                          label="Estados"
                          value={statusFilter}
                          onChange={(e) => {
                            handleState(e.target.value)
                          }}
                        >
                          <MenuItem value={''}>Seleccione una opción</MenuItem>
                          {statesCodesDraft &&
                            statesCodesDraft.map((item, key) => (
                              <MenuItem key={item.id} value={item.id}>
                                {item.value}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                  <Grid
                    md={6}
                    sm={6}
                    xs={12}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginBottom: '10px',
                    }}
                  >
                    {/*  <Grid md={12} sm={12}>
                      <FormControl fullWidth>
                        <InputLabel>Etapa</InputLabel>
                        <Select
                          id=""
                          label="Etapa"
                          value={projectStage}
                          onChange={(e) => {
                            handleProjectStage(e.target.value)
                          }}
                        >
                          <MenuItem value={''}>Seleccione una opción</MenuItem>
                          {stage &&
                            stage.map((item, key) => (
                              <MenuItem key={key} value={item.description}>
                                {item.description}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </Grid> */}

                    <Grid md={11} sm={11} xs={10}>
                      <FormControl fullWidth disabled={listDraftForms.loading}>
                        <InputLabel>Etapa</InputLabel>
                        <Select
                          id=""
                          label="Etapa"
                          value={projectStage}
                          onChange={(e) => {
                            handleProjectStage(e.target.value)
                          }}
                        >
                          <MenuItem value={''}>Seleccione una opción</MenuItem>
                          <MenuItem value="PreElegibilidad">
                            PreElegibilidad
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </div>
              </Grid>
            </div>
          </Grid>
        </Grid>
        <div className="tableData">
          <Suspense
            fallback={
              <div
                style={{
                  display: 'flex',
                  width: '100%',
                  height: '40vh',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Box
                  style={{
                    marginTop: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <CircularProgress />
                </Box>
              </div>
            }
          >
            <TableData
              rows={rows}
              loading={listDraftForms.loading}
              getFiltersDraftForms={getFiltersDraftForms}
            />
          </Suspense>
        </div>
      </div>
    </Grid>
  )
}

export default React.memo(ViewForms)
